// extracted by mini-css-extract-plugin
export default {"IncludeTargetIcon":"IncludeExcludeTarget-module__IncludeTargetIcon--Vlhwm","ExcludeTargetIcon":"IncludeExcludeTarget-module__ExcludeTargetIcon--fOSjK"};